export function isElementVisible(el: Element, scroll?: boolean): boolean {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/helpers/element-is-visible.ts